import React, { useState } from "react";
import { Modal } from "@/components/ui";
import { SiteVisitWizard } from "../components/SiteVisitWizard";

export const UpdateSiteVisitForm = ({ isOpen, onClose, onSubmit, initialData }) => {
  const [loading, setLoading] = useState(false);

  if (!isOpen || !initialData) return null;

  const fullName = initialData?.customerName || `${initialData?.firstName || ""} ${initialData?.lastName || ""}`.trim() || "No Name";

  const handleSubmit = async (data) => {
    setLoading(true);
    try {
      await onSubmit(initialData._id, data);
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`UPDATE SITE VISIT: ${fullName.toUpperCase()}`}
      size="3xl"
    >
      <div className="w-full">
        <SiteVisitWizard
          initialData={initialData}
          lead={initialData}
          fullName={fullName}
          onSubmit={handleSubmit}
          onCancel={onClose}
          loading={loading}
        />
      </div>
    </Modal>
  );
};
